import React,{useState,useEffect} from "react";
import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";
import "./Dashboard.scss";



export default function Dashboard() {
    const [logs, setLogs] = useState([]);
    const [totalFailed, setTotalFailed] = useState(0);
    const [recentFailed, setRecentFailed] = useState(0);
	const [updatedPluginList, setUpdatedPluginList] = useState([]);
	const [outdatedPLuginsNumber, setOutdatedPLuginsNumber] = useState(0);
	const [siteHealthReport, setSiteHealthReport] = useState([]);
	const [siteHealthStatus, setSiteHealthStatus] = useState('');
	const [totalIssues, setTotalIssues] = useState(0);
	const [criticalThreats, setCriticalThreats] = useState(0);
	const [loading, setLoading] = useState(false);

	const refreshAll = () => {
		// Set loading to true to start the rotation
		setLoading(true);
		
		// Fetch data
		fetchLogs();
		fetchPluginList();
		fetchSiteHealthReport();
		
		// Ensure the rotation lasts at least 1 second
		setTimeout(() => {
		  setLoading(false);
		}, 1000);
	  }
	useEffect(()=> {
		fetchLogs();
		fetchPluginList();
		fetchSiteHealthReport();
	},[])

	

	const fetchLogs = async () => {
		try {
			const results = await apiFetch({
				path: "/ultimate-security/v1/get-login-failed-logs",
				method: "GET"
			});

			setTotalFailed(results.total_failed || 0);
			setRecentFailed(results.recent_failed || 0);
			setLogs(results.logs || []);
		} catch (error) {
			console.error("Error fetching logs:", error);
		}
	};

	
	const fetchPluginList = async () => {
		try {
			const results = await apiFetch({ 
				path: "/ultimate-security/v1/update-plugin-info", 
				method: "GET" 
			});
			
			// console.log("Raw API response:", results);
	
			const pluginList = Array.isArray(results.plugins_with_updates) ? results.plugins_with_updates : [];
			
	
			setUpdatedPluginList(pluginList);
			setOutdatedPLuginsNumber(pluginList.length);
	
		} catch (error) {
			// console.error("Error fetching PluginList:", error);
			setUpdatedPluginList([]); // fallback to empty list
			setOutdatedPLuginsNumber(0); // reset count
		}
	};
	
	const fetchSiteHealthReport = async () => {
		try {
			const results = await apiFetch({ 
				path: "/ultimate-security/v1/site-health-report", 
				method: "GET" 
			});
			// console.log(results);
			setSiteHealthStatus(results.status);
			setTotalIssues(results.total_issues);
			setCriticalThreats(results.critical_count);
			setSiteHealthReport(results.critical_issues);
			
			
		} catch (error) {
			// console.error("Error fetching Report:", error);
		}
	};


	return (
		<div className="ultimate-security-dashboard-content">
			<div className="mb-3 text-end">
				
				<img className={loading ?'rotate':''} src={ultimate_security_ajax_obj.imageUrl+'ipReload.svg'} alt="" onClick={refreshAll} />
			</div>
			<div className="row mb-3">
				{/* Top stats cards */}
				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={ultimate_security_ajax_obj.imageUrl+'issues_found.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{totalIssues}</h2>
								<p className="text-text mb-0 small">
									{__("Issues Found", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={ultimate_security_ajax_obj.imageUrl+'critical_threats.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{criticalThreats}</h2>
								<p className="text-text mb-0 small">
									{__("Critical Threats", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={ultimate_security_ajax_obj.imageUrl+'outdated_plugins.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{outdatedPLuginsNumber}</h2>
								<p className="text-text mb-0 small">
									{__("Outdated Plugins", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
							
					<div className="dash-card " style={{height: "92px"}}>
						<div className="card-body p-4 d-flex align-items-center">
							<div
								className="me-3 d-flex align-items-center justify-content-center"
								style={{ width: "50px", height: "50px" }}
							>
                                <img src={ultimate_security_ajax_obj.imageUrl+'failed_logins.svg'} alt="icon" />
							</div>
							<div>
								<h2 className="pl-heading-1 mb-0 fw-bold">{totalFailed}</h2>
								<p className="text-text mb-0 small">
									{__("Failed Logins", "ultimate-security")}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row mb-3">
				{/* Middle section */}
				<div className="col-md-3">
					<div className="dash-card " style={{height: "230px"}}>
						<div className="card-body p-4">
							<h5 className="card-title mb-4">
								{__("Failed Login Attempts", "ultimate-security")}
							</h5>
							<div className="d-flex align-items-center">
								<div
									className=" me-4 d-flex align-items-center justify-content-center"
									style={{ width: "90px", height: "85px" }}
								>
									 <img src={ultimate_security_ajax_obj.imageUrl+'failed_login_attempt.svg'} alt="icon" />
								</div>
								<div>
									<p className="mb-0 fw-medium">
										{recentFailed>0 ? __(recentFailed,"ultimate-security") : __("Hooray! Zero ","ultimate-security")} {__("failed login attempts in the (past 24 hours)", "ultimate-security")}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="dash-card " style={{height: "230px"}}>
						<div className="card-body p-4">
							<h5 className="card-title mb-4">{__("Security Status", "ultimate-security")}</h5>
							<div className="d-flex align-items-center">
								<div
									className="bg-primary bg-opacity-10 text-primary rounded-circle p-4 me-4 d-flex align-items-center justify-content-center"
									style={{ width: "64px", height: "64px" }}
								>
									<img src={siteHealthStatus === "good" ? ultimate_security_ajax_obj.imageUrl+'good.svg' : ultimate_security_ajax_obj.imageUrl+'critical.svg' } alt="iocn" />
								</div>
								<div>
									<h4 className="pl-heading fw-bold mb-1">{__(siteHealthStatus, "ultimate-security")}</h4>
									<p className="mb-0">
										{siteHealthStatus === "good" ? __("Your site is protected and no issues detected.","ultimate-security") : __("Your site is not protected.","ultimate-security")}	
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Bottom section */}
				<div className="col-md-6">
					<div className="dash-card " style={{height: "230px"}}>
						<div className="card-body p-4">
							<h5 className="card-title mb-4">{__("Login Logs", "ultimate-security")}</h5>
							<ul className="list-unstyled">
								{logs.slice(0, 5).map((log, index) => (
									<li key={index} className="mb-2" style={{ fontSize: "13px" }}>
										{log.success ? "✓" : "✗"}{" "}
										<strong>{log.success ? __("Successful", "ultimate-security") : __("Failed", "ultimate-security")}</strong> {__("login by", "ultimate-security")}{" "}
										<code>{log.username}</code> {__("at", "ultimate-security")}{" "}
										{new Date(log.timestamp * 1000).toLocaleString()} {__("from", "ultimate-security")}{" "}
										<code>{log.ip}</code>
									</li>
								))}
							</ul>

						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-6">
					<div className="dash-card " style={{height: "230px"}}>
						<div className="card-body p-4 d-flex flex-column">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<h5 className="card-title mb-0">
									{__("Critical Threats", "ultimate-security")}
								</h5>
								<a
									href={ultimate_security_ajax_obj.admin_url + 'site-health.php'}
									className="text-decoration-none small"
                                    style={{color: "#873EFF"}}
								>
									{__("VIEW ALL", "ultimate-security")}
								</a>
							</div>
							<ul className="list-unstyled mb-0">
								{siteHealthReport.slice(0, 5).map((report, index) => (
									<li key={index} className="mb-2">
										<span className="pl-heading-1fw-bold text-danger">{__(report.label, "ultimate-security")}</span>
									</li>
								))}
								
							</ul>
						</div>
					</div>
				</div>

				<div className="col-md-6">
					<div className="dash-card " style={{height: "230px"}}>
						<div className="card-body p-4 d-flex flex-column">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<h5 className="card-title mb-0">
									{__("Plugin Updates", "ultimate-security")}
								</h5>
								<a
									href={ultimate_security_ajax_obj.admin_url + 'plugins.php?plugin_status=upgrade'}
									className="text-decoration-none small"
                                    style={{color: "#873EFF"}}
								>
									{__("VIEW UPDATES", "ultimate-security")}
								</a>
								
							</div>
							<ul className="list-unstyled mb-0">
								{updatedPluginList.slice(0, 5).map((plugin, index) => (
								<li key={index} className="mb-2" style={{ fontSize: "13px" }}>
									{plugin.name} - <span className="fw-bold text-danger">
									{plugin.current_version || "Unknown"} → {plugin.new_version}
									</span>
								</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
